import { AudienceFilters, AudienceSegment, NotificationChannel } from "../types";

export const CHANNEL_OPTIONS: Array<{
  value: NotificationChannel;
  label: string;
  comingSoon?: boolean;
}> = [
  { value: "email", label: "Email" },
  { value: "sms", label: "SMS", comingSoon: true },
  { value: "push", label: "Push Notification", comingSoon: true },
];

export const SEGMENT_OPTIONS: Array<{ value: AudienceSegment; label: string }> = [
  { value: "all", label: "All Customers" },
  { value: "approved", label: "Approved Customers" },
  { value: "pending-review", label: "Pending Review" },
  { value: "rejected", label: "Rejected Customers" },
];

// Countries and wallet currencies TradeVu actually supports (mirrors
// AVAILABLE_WALLETS in trade-vu-backend/src/kyb/service/kyb.service.ts,
// the same source the customer-facing web app's wallet setup step uses).
// Kept in sync with COUNTRY_VALUE_MAP in
// trade-vu-backend/src/broadcast-notification/repository/broadcast-notification.repository.ts.
export const COUNTRY_OPTIONS: Array<{ value: string; label: string }> = [
  { value: "all", label: "All" },
  { value: "nigeria", label: "Nigeria" },
  { value: "ghana", label: "Ghana" },
  { value: "kenya", label: "Kenya" },
  { value: "united-states", label: "United States" },
  { value: "united-kingdom", label: "United Kingdom" },
  { value: "canada", label: "Canada" },
  { value: "china", label: "China" },
  { value: "united-arab-emirates", label: "United Arab Emirates" },
];

export const CURRENCY_OPTIONS: Array<{ value: string; label: string }> = [
  { value: "all", label: "All" },
  { value: "NGN", label: "NGN — Nigerian Naira" },
  { value: "GHS", label: "GHS — Ghanaian Cedi" },
  { value: "KES", label: "KES — Kenyan Shilling" },
  { value: "USD", label: "USD — US Dollar" },
  { value: "USDT", label: "USDT — Tether" },
  { value: "USDC", label: "USDC — USD Coin" },
  // { value: "EUR", label: "EUR — Euro" },
  // { value: "GBP", label: "GBP — British Pound" },
  // { value: "CAD", label: "CAD — Canadian Dollar" },
  // { value: "CNY", label: "CNY — Chinese Yuan" },
  // { value: "AED", label: "AED — UAE Dirham" },
  // { value: "XAF", label: "XAF — Central African CFA Franc" },
  // { value: "XOF", label: "XOF — West African CFA Franc" },
];

export const MESSAGE_KEYWORDS: Array<{ token: string; label: string }> = [
  { token: "{{firstName}}", label: "First name" },
  { token: "{{lastName}}", label: "Last name" },
  { token: "{{businessName}}", label: "Business name" },
  { token: "{{email}}", label: "Email" },
];

export const DEFAULT_AUDIENCE_FILTERS: AudienceFilters = {
  targetType: "segment",
  segment: "all",
  country: "all",
  currency: "all",
  customers: [],
};

export const formatAudienceSummary = (filters: AudienceFilters): string => {
  if (filters.targetType === "customer") {
    if (filters.customers.length === 0) return "Specific customers";
    if (filters.customers.length === 1) {
      return `${filters.customers[0].label} (specific customer)`;
    }
    return `${filters.customers[0].label} +${filters.customers.length - 1} more (specific customers)`;
  }

  const parts = [
    SEGMENT_OPTIONS.find((option) => option.value === filters.segment)?.label ??
      filters.segment,
  ];

  if (filters.country !== "all") {
    parts.push(
      COUNTRY_OPTIONS.find((option) => option.value === filters.country)?.label ??
        filters.country,
    );
  }

  if (filters.currency !== "all") {
    parts.push(filters.currency);
  }

  return parts.join(" · ");
};
